import React from 'react';
import { HomeSectionProps } from './HomeSectionProps';

const steps = [
  {
    number: 1,
    title: '팀 구성하기',
    description: 'KBO 리그의 실제 선수들 중에서 투수, 타자를 선택해 나만의 드림팀을 구성하세요.',
    colorClass: 'bg-danger',
  },
  {
    number: 2,
    title: '경기 관전하기',
    description: '실제 KBO 경기가 진행되는 동안 선수들의 활약을 지켜보세요. 모든 플레이가 실시간으로 반영됩니다.',
    colorClass: 'bg-primary',
  },
  {
    number: 3,
    title: '순위 경쟁하기',
    description: '친구들과 프라이빗 리그를 만들거나 공개 리그에 참여해 순위를 겨뤄보세요.',
    colorClass: 'bg-success',
  },
];

const HowToPlay: React.FC<HomeSectionProps> = ({ className }) => {
  return (
    <section id="how-to-play" className={`py-5 keep-all ${className ?? ''}`}>
      <div className="container py-5">
        <div className="text-center mb-5">
          <span className="badge rounded-pill text-bg-primary bg-opacity-75 mb-3">게임 방법</span>
          <h2 className="fw-bold">간단한 3단계로 시작하세요</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>복잡한 규칙 없이 누구나 쉽게 즐길 수 있는 판타지 야구 게임</p>
        </div>
        <div className="row g-4">
          {steps.map((step) => (
            <div key={step.number} className="col-md-4">
              <div className="card shadow-sm h-100 text-center border-0" style={{ transition: 'box-shadow 0.3s ease-in-out' }}>
                <div className="card-body p-5">
                  <div className={`d-inline-flex align-items-center justify-content-center ${step.colorClass} bg-gradient rounded-circle text-white mb-4`} style={{ width: '64px', height: '64px' }}>
                    <span className="fs-3 fw-bold">{step.number}</span>
                  </div>
                  <h3 className="card-title h4 fw-semibold">{step.title}</h3>
                  <p className="card-text text-muted">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToPlay;
